import GroupImg from "../Assets/Images/Group.svg";

const HomeContent = () => {
  return (
    <div className="relative bg-night overflow-hidden">
      <div className="glow-orb w-[300px] h-[300px] bg-neonCyan/15 bottom-0 -left-20"></div>
      <div className="max-w-[1140px] mx-auto py-24 p-4 relative">
        <div className="grid lg:grid-cols-2 gap-10 md:grid-cols-1 items-center">
          <div className="animate-float">
            <img src={GroupImg} alt="" />
          </div>
          <div className="glass-card p-10">
            <h1
              data-aos="fade-left"
              className="text-2xl sm:text-3xl lg:text-4xl font-bold sm:leading-10 text-white"
            >
              Why Choose <span className="text-gradient">SpaceX?</span>
            </h1>
            <div className="web3-underline w-[70px] mt-3"></div>
            <p className="py-6 text-lg text-gray-400">
              As a software development company, we make use of top-notch
              solutions to digitally transform your business and take it to new
              heights.
            </p>
            <p className="pb-2 text-lg text-gray-400">
              Transforming your  ideas into tangible reality is our
              expertise. We are committed to delivering quality solutions at
              every stage of the process. With a deep understanding of
               software development, we are dedicated to
              providing innovative solutions tailored to your specific business
              requirements.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeContent;
